import { createSlice } from "@reduxjs/toolkit";
import customerInfoSchema from "./customerInfoSchema"; // ✅ import your new schema

const initialState = { 
  customerData: 
    { firstName: "", 
      middleInitial: "", 
      lastName: "", 
      suffix: "", 
      emailAddress: "", 
      mobileNumber: "", 
      address: "", 
      consent: "False",
      withDetails : "False" }, 
    errors: {}, 
    isValid: true,  //    SET FALSE THIS IF REQUIRED FIELD IS NEEDED
    errorCount: 0,
    customerDataUpdating : false
  };

const customerInformationSlice = createSlice({
    name: "census",
    initialState,
    reducers: {
        updateCustomerField: (state, action) => {
          const { field, value } = action.payload;
          state.customerData[field] = value;
          state.customerDataUpdating = true
          
          // Skip validation for consent
          if (field === "consent") return;

          // ✅ Validate only the updated field
          try {
            customerInfoSchema.validateSyncAt(field, state.customerData);
            state.errors[field] = "";
          } catch (err) {
            state.errors[field] = err.message;
          }

          // Apply custom "all-or-none" required logic

          applyAllOrNoneRequired(state, "UPDATE_FIELD");
          const noErrors = Object.values(state.errors).every((msg) => !msg);

          //    UNCOMMENT THIS IF REQUIRED FIELD IS NEEDED
          //state.isValid = allRequiredFilled && noErrors; // remove comment if required rule is needed
          state.isValid = noErrors;
          state.errorCount = Object.values(state.errors).filter((msg) => msg).length;
        },
        validateAll: (state) => {
            state.customerDataUpdating = false
            try {
                customerInfoSchema.validateSync(state.customerData, { abortEarly: false });
                state.errors = {};
                state.isValid = true;
            } catch (err) {
                const errors = {};
                err.inner.forEach((e) => {
                    errors[e.path] = e.message;
                });
                state.errors = errors;
                state.isValid = false;
            }
            
            // Apply custom "all-or-none" required logic
            if(state.isValid) applyAllOrNoneRequired(state, "VALIDATE_ALL");
            state.errorCount = Object.values(state.errors).filter((msg) => msg).length;
        },

        resetCustomer: (state) => {
          state.customerData = { ...initialState.customerData };
          state.errors = {};
          state.isValid = true; //    SET FALSE THIS IF REQUIRED FIELD IS NEEDED
          state.errorCount = 0;
        },
    },
});

const requiredFields = ["firstName", "lastName", "mobileNumber"];

const applyAllOrNoneRequired = (state, action) => {
  const { customerData, errors } = state;

  const anyFilled = requiredFields.some(f => !!String(customerData[f] ?? "").trim());
  const allFilled = requiredFields.every(f => !!String(customerData[f] ?? "").trim());

  // ✅ Track withDetails as a boolean
  customerData.withDetails = allFilled ? "True" : "False";

  const shouldValidate = action === "VALIDATE_ALL";

  if (shouldValidate) {
    if (anyFilled) {
      // 🔹 Add errors for every missing required field
      requiredFields.forEach(f => {
        if (!customerData[f]?.trim()) {
          errors[f] = "This field is required.";
        }
      });
    } else {
      // 🔹 All fields filled → clear any old errors
      requiredFields.forEach(f => delete errors[f]);
    }
  } else {
    // 🔹 Outside of validation, clear errors for unfilled fields
    requiredFields.forEach(f => {
      if (!customerData[f]?.trim()) {
        delete errors[f];
      }
    });
  }

  // ✅ Final validity check
  state.isValid = !Object.values(errors).some(Boolean);
};

export const { updateCustomerField, validateAll, resetCustomer } = customerInformationSlice.actions;
export default customerInformationSlice.reducer;
